import {
    Component,
    ViewChild,
    OnInit,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    ChangeDetectorRef,
    OnDestroy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { StatusCodeService } from 'app/shared/services/status-code.service';
import { UiUtilsService } from 'app/shared/utils/ui-utils.service';
import { DomOperationUtilsService } from 'app/shared/utils/dom-operation-utils.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FilterDataSource } from 'app/shared/data/filter-data-source';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from 'app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/shared/services/shared.service';
import { CustomerService } from 'app/shared/services/customer.service';
import {
    Active,
    All,
    AppQueryParams,
    customerFilter,
    customerQueryParam,
    activeInactiveLocationQueryParam,
    GetCustomerFeatureResponse,
    GetCustomerSummary,
    InActive,
    userSearchPageIndexParam,
    userSearchPageSizeParam,
    userSearchParam,
    SubscriptionsInfoTier,
    SubscriptionsInfoFeatures,
    sortValueParam,
    sortDirectionParam,
} from 'app/shared/models/customer';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FEATURE_IDS, USER_ROLES } from '../users.service';
import { CUSTOMER_SLIICER_FEATURE_ID } from 'app/shared/services/sliicer.service';
import { UsersInfo } from 'app/shared/models/users';
import { TrackBy } from 'app/shared/utils/track-by';
import { SelectOptionType } from 'app/shared/models/add-edit-location';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { StringUtils } from 'app/shared/utils/string-utils';

const PAGESIZE = 25;
const MINPAGESIZE = 0;

const CUSTOMER_NAME_COLUMN = 'name';
const CUSTOMER_CUSTOMERNAME_COLUMN = 'customerName';

@Component({
    selector: 'app-admin-customer-editor',
    templateUrl: './admin-customer.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./admin-customer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminCustomerComponent implements OnInit, OnDestroy {
    public searchString = new FormControl();
    public customers = new Array<GetCustomerSummary>();
    public customerSummary = new Array<GetCustomerSummary>();
    public filteredData = new Array<GetCustomerSummary>();
    private subscriptions = new Array<Subscription>();
    public customerDataChange: BehaviorSubject<GetCustomerSummary[]> = new BehaviorSubject<GetCustomerSummary[]>([]);
    public initialData = new BehaviorSubject<GetCustomerSummary[]>([]);
    public customerDataSource: MatTableDataSource<GetCustomerSummary> | null = new MatTableDataSource([]);
    public totalPaginationLength: number;
    @ViewChild(MatPaginator, { static: true }) public customerPaginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) public customerSort: MatSort;
    public customerFilterColumns = [
        CUSTOMER_NAME_COLUMN,
        'activeLocations',
        'inactiveLocations',
        'subscriptionLevel',
        'addOns',
        'active',
        'editCustomer',
    ];
    public customerEdited: number;
    public customerEditedName: string;
    public showNewCustomerEditor: boolean;
    public isMatTableVisible = true;
    public loggedInUserRole: string;
    public isCustomer = true;
    public addNewCustomerVisible: boolean;
    /**
     * Indicates the loading state of the component.
     */
    public isLoading: boolean;
    public allCustomerFeatures = new Array<GetCustomerFeatureResponse>();
    public featureList = new Array<GetCustomerFeatureResponse>();
    public showCustomerSearch: boolean;
    public activeInactiveList: SelectOptionType[];
    public activeInactiveCustomers = new Array<GetCustomerSummary>();
    public selectedCustomerID: number;
    public customerID: number;
    public currentCustomerID: number;
    public includeActiveInactiveLocations: number;
    public showUpdateCustomerEditor: boolean;
    public activateStatus: boolean;
    public snackbarSuccessMsg: string;
    public snackbarErrMsg: string;
    public dismissBtnText: string;
    public isCustomerStatusChanged: boolean;
    public startPage: number;
    public pageSize: number;
    public searchValue: string;
    public isCustomerEdited: boolean;
    public customerName: string;
    public isActiveInactiveFilter: boolean;
    public eventValue: string;
    public rowCount: number;
    public inActivationHeader: string;
    public inActivationMessage: string;
    public cancel: string;
    public confrim: string;
    public pageIndex: number;
    public dontShowActiveInactiveTab: boolean;
    public availablePageHint = false;
    public isActive: string;
    public subscriptionLevelTiers: SubscriptionsInfoTier[] = [];
    public subscriptionLevelFeatures: string[] = [];
    public availableAddOns: SubscriptionsInfoFeatures[] = [];
    public canAccessCustomerEditor: boolean;

    public filters = {
        subscriptionLevels: new Array<number>(),
        assignedAddOns: new Array<number>()
    }

    public trackById = TrackBy.byId;
    public trackByValue = TrackBy.byValue();
    public trackByLevel = TrackBy.byUniqueKey<SubscriptionsInfoTier>()('level');
    constructor(
        private domOperationUtilsService: DomOperationUtilsService,
        private cdr: ChangeDetectorRef,
        private matDialog: MatDialog,
        private sharedService: SharedService,
        private customerService: CustomerService,
        private statusCodeService: StatusCodeService,
        private uiUtilsService: UiUtilsService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private snackBar: MatSnackBar,
        private translate: TranslateService,
    ) {

    }

    public ngOnInit() {
        // Checks if page hint is available
        this.subscriptions.push(
            this.domOperationUtilsService.showpageHint.subscribe((result: boolean) => {
                this.availablePageHint = result;
                this.uiUtilsService.safeChangeDetection(this.cdr);

                if (this.availablePageHint) {
                    document.body.style.overflow = 'hidden';
                    this.domOperationUtilsService.scrollToTop('html');
                } else {
                    document.body.style.overflow = 'auto';
                }
            }),
        );
        this.subscriptions.push(
            this.customerService.getSubscriptionInfo().subscribe((res) => {
                this.subscriptionLevelTiers = [];
                this.subscriptionLevelFeatures = [];
                for(const tier of res.subscriptions) {
                    this.subscriptionLevelTiers[tier.level] = tier;
                    let description = '';

                    tier.features.sort((a, b) => a.name.localeCompare(b.name));
                    for(const feature of tier.features) {
                        if(description !== '') description += ', ';
                        description += `${feature.displayname}`;
                    }
                    this.subscriptionLevelFeatures[tier.level] = description;

                }
                this.availableAddOns = [res.availableAddOns?.find((feature) => feature.id === CUSTOMER_SLIICER_FEATURE_ID)];
            })
        )
        this.dontShowActiveInactiveTab = true;
        this.statusCodeService.userInfo.subscribe((res: UsersInfo) => {
            if (res.features) {
                this.canAccessCustomerEditor = res.features.some((feature) => feature.id === FEATURE_IDS.CUSTOMER_EDITOR);
                if (!this.canAccessCustomerEditor) {
                    this.router.navigate(['/dashboard'], {
                        relativeTo: this.activatedRoute,
                    });
                    return;
                }
            }
            if (res.userRole) this.loggedInUserRole = res.userRole[0];
            this.dontShowActiveInactiveTab = this.loggedInUserRole !== 'Admin' && this.loggedInUserRole !== 'CustomerAdmin';
            this.addNewCustomerVisible = this.loggedInUserRole === USER_ROLES.ADMIN ;
        });

        this.translate.get('COMMON.DISMISS_TEXT').subscribe((res: string) => {
            this.dismissBtnText = res;
        });
        this.translate.get('ADMIN.CUSTOMER_ACTIVATED_INACTIVATED_SUCCESS_MESSAGE').subscribe((res: string) => {
            this.snackbarSuccessMsg = res;
            this.uiUtilsService.safeChangeDetection(this.cdr);
        });
        this.translate.get('ADMIN.CUSTOMER_ACTIVATED_INACTIVATED_ERROR_MESSAGE').subscribe((res: string) => {
            this.snackbarErrMsg = res;
        });
        this.translate.get('ADMIN.CONFIRM_INACTIVATION_TEXT').subscribe((res: string) => {
            this.inActivationHeader = res;
        });
        this.translate.get('ADMIN.INACTIVATION_MESSAGE').subscribe((res: string) => {
            this.inActivationMessage = res;
        });
        this.translate.get('ADMIN.CONFIRM').subscribe((res: string) => {
            this.confrim = res;
        });
        this.translate.get('ADMIN.CANCEL').subscribe((res: string) => {
            this.cancel = res;
        });
        this.isLoading = true;
        this.statusCodeService.customerIdInEditScreen.subscribe((customerId: number) => {
            this.customerEdited = customerId;
        });
        this.statusCodeService.customerIdInEditName.subscribe((customerName: string) => {
            this.customerEditedName = customerName;
        });
        // subscribe to route change
        if (this.customerEditedName !== '' && this.customerEditedName !== undefined) {
            this.statusCodeService.customerIdInEditName.next('');
        }

        this.subscriptions.push(
            this.activatedRoute.queryParamMap.subscribe(
                (params: ParamMap) => {
                    this.currentCustomerID = Number(params.get(customerQueryParam));
                    this.includeActiveInactiveLocations = Number(params.get(activeInactiveLocationQueryParam));

                    this.searchValue = params.get(userSearchParam);
                    this.startPage = Number(params.get(userSearchPageIndexParam));
                    this.pageSize = Number(params.get(userSearchPageSizeParam));
                    this.pageIndex = Number(params.get(userSearchPageIndexParam));
                    this.isCustomerEdited = true;

                    if(params.has(sortValueParam)) {
                        this.customerSort.active = params.get(sortValueParam);
                        this.customerSort.direction = params.get(sortDirectionParam) as SortDirection;
                        // #47679 Need to emit event so UI will display sort arrow on the column
                        this.customerSort.sortChange.emit({active: this.customerSort.active, direction: this.customerSort.direction});
                    }

                    if (this.searchValue) {
                        this.searchString.setValue(this.searchValue);
                    }

                    this.customerPaginator.pageIndex = this.pageIndex;
                    this.customerPaginator.pageSize = this.pageSize;

                    this.customerDataSource.sort = this.customerSort;

                    this.isCustomer = true;
                    this.getCustomerSummary();

                    this.setUpSearch();
                }
            )
        );


        // get all features for user/customer
        const customeFeatureSubscription = this.sharedService
            .getFeatures()
            .subscribe((response: GetCustomerFeatureResponse[]) => {
                if (response) {
                    this.allCustomerFeatures = response;
                    this.featureList = response.filter((x) => x.canassigncustomer);
                }
            });
        this.subscriptions.push(customeFeatureSubscription);

        this.activeInactiveList = [
            { value: '1', text: 'All' },
            { value: '2', text: 'Active' },
            { value: '3', text: 'Inactive' },
        ];

    }

    private setUpSearch() {
        /*  Search by user name & roles  */
        this.searchString.valueChanges
            .pipe(debounceTime(400))
            .pipe(distinctUntilChanged())
            .subscribe((res: string) => {
                this.searchValue = res;
                this.isCustomer = true;
                this.getCustomerSummary();
            });
    }
    /**
     * Method activate/inactivate customers based on toggle
     * @param customerId and activateStatus
     */
    public activateCustomer(customer: GetCustomerSummary, customerId: number) {
        this.customerName = customer.name;
        if (customer.active) {
            this.matDialog
                .open(ConfirmationDialogComponent, {
                    disableClose: true,
                    data: {
                        title: this.inActivationHeader,
                        message: this.inActivationMessage,
                        okText: this.confrim,
                        cancelText: this.cancel,
                    },
                })
                .afterClosed()
                .subscribe((result) => {
                    if (result.whichButtonWasPressed === 'ok') {
                        this.isLoading = true;
                        this.changeState(customerId, false);
                    } else {
                        this.generateUserTable(this.customerSummary);
                    }
                });
        } else {
            this.isLoading = true;
            this.changeState(customerId, true);
        }
    }
    public changeState(customerId: number, status: boolean) {
        this.customerService.activateStatus(customerId, status).subscribe(
            () => {
                this.isCustomerStatusChanged = true;
                this.isCustomer = true;
                this.getCustomerSummary();
                this.isLoading = false;
                this.uiUtilsService.safeChangeDetection(this.cdr);
            },
            () => {
                // snak bar message when error occured
                this.snackBar.open(StringUtils.joinWithSingleSpace(this.snackbarErrMsg, this.customerName), this.dismissBtnText, {
                    panelClass: 'custom-error-snack-bar',
                });
            },
        );
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    /**
     * Method sets customer search filter to show /hide
     * @param value - show/hide customer search filters
     */
    public showCustomersFilters(value?: boolean) {
        if (value == null) {
            this.showCustomerSearch = !this.showCustomerSearch;
            if (this.showCustomerSearch === false) {
                this.filterCustomers();
                this.filters.assignedAddOns = [];
            }
            return;
        }
        this.showCustomerSearch = value;
    }
    /**
     * Method filters customer based on selected feature
     * @param value - $event which is an array of features
     */
    public getCustomerByAddOns(eventValue: number[]) {
        this.isCustomer = true;
        this.filters.assignedAddOns = [];
        const isAddOnSelected = eventValue.length > 0;
        if (isAddOnSelected) {
            this.filters.assignedAddOns.push(...eventValue);
        }
        this.customerPaginator.pageIndex = 0;
        this.getCustomerSummary();
    }
    public onSubscriptionFilterChange(event: number[]) {
        this.filters.subscriptionLevels = event;
        this.isCustomer = true;
        this.customerPaginator.pageIndex = 0;
        this.getCustomerSummary();
    }
    /**
     * Method generates a table of customers based on active/inactive flag
     */
    public onSelection(eventValue: string) {
        this.isCustomer = true;
        if (eventValue === Active) {
            this.isActive = customerFilter.Active;
        } else if (eventValue === InActive) {
            this.isActive = customerFilter.Inactive;
        } else if (eventValue === All) {
            this.isActive = customerFilter.All;
        }
        this.customerPaginator.pageIndex = 0;
        this.getCustomerSummary();
    }

    public filterCustomers() {
        this.pageIndex = 0;
        this.customerPaginator.pageIndex = 0;

        this.filteredData = this.customerSummary;

        this.filteredData =
            this.eventValue === 'Active' || this.eventValue === 'Inactive'
                ? this.filteredData.filter((customer) => customer.active === (this.eventValue === 'Active'))
                : this.customerSummary;
        this.isMatTableVisible = this.filteredData.length > 0;
        this.totalPaginationLength = this.filteredData.length;
        this.generateUserTable(this.filteredData);
    }
    public onPageChange(event: PageEvent): void {
        this.isCustomer = true;
        this.getCustomerSummary(event);
    }

    public onDataSort() {
        // #47679 On return event is triggered without user choice. There is no data when it happens.
        // #47679 If there is no data then table is hidden and sorting is not possible
        if(this.customerDataSource.data.length !== 0) {
            this.pageIndex = 0;
            this.customerPaginator.pageIndex = this.pageIndex;
            this.isCustomer = true;
            this.getCustomerSummary();
        }
    }

    public getCustomerSummary(event?: PageEvent) {
        if (this.filters.assignedAddOns && this.filters.assignedAddOns.length > 0) {
            this.filters.assignedAddOns = this.filters.assignedAddOns.filter(
                (item, index) => this.filters.assignedAddOns.indexOf(item) === index,
            );
        }
        this.isLoading = true;
        this.uiUtilsService.safeChangeDetection(this.cdr);
        if (event) {
            this.startPage = event.pageIndex;
            this.pageSize = event.pageSize;
        } else if (!this.isCustomerEdited) {
            this.pageSize = 25;
            this.startPage = 0;
        }
        if (this.isCustomerEdited) {
            this.startPage = this.pageIndex;
            this.pageSize = this.pageSize === MINPAGESIZE ? (this.pageSize = PAGESIZE) : this.pageSize;
            this.customerPaginator.pageIndex = this.startPage;
            this.customerPaginator.pageSize = this.pageSize;
        }

        let sort: {value: string, direction: string} = null;
        if(this.customerSort.active && this.customerSort.direction) {
            sort = {
                value: this.customerSort.active !== CUSTOMER_NAME_COLUMN ? this.customerSort.active : CUSTOMER_CUSTOMERNAME_COLUMN,
                direction: this.customerSort.direction
            };
        }

        // get all customer summary
        const customersummarySubscription = this.customerService
            .getCustomerSummaryV2(
                this.startPage + 1,
                this.pageSize,
                this.searchValue,
                this.isActive,
                this.filters.subscriptionLevels,
                this.filters.assignedAddOns,
                false,
                sort
            )
            .subscribe(
                () => {
                    if (this.isCustomer) {
                        const customerSummaryData = this.customerService.customerSummary;

                        if (customerSummaryData && customerSummaryData.length > 0) {
                            if (this.isCustomerStatusChanged) {
                                // snak bar message
                                const simpleSnackBarRef = this.snackBar.open(
                                    StringUtils.joinWithSingleSpace(this.customerName, this.snackbarSuccessMsg),
                                    this.dismissBtnText,
                                );
                                setTimeout(simpleSnackBarRef.dismiss.bind(simpleSnackBarRef), 10000);
                            }
                            this.rowCount = this.customerService.summaryRowCount;
                            this.isCustomerEdited = false;
                            this.isCustomerStatusChanged = false;
                            this.customers = this.customerSummary = this.filteredData = customerSummaryData;
                            this.initialData.next(this.customers);
                            this.generateUserTable(this.customerSummary);
                            this.isLoading = false;
                            this.customerService.summaryRowCount = undefined;
                            this.customerService.customerSummary = undefined;
                            this.uiUtilsService.safeChangeDetection(this.cdr);
                        }
                        this.isLoading = false;
                        this.isMatTableVisible = customerSummaryData.length > 0;
                        this.isCustomer = false;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                    }
                },
                () => {
                    this.isLoading = false;
                    this.customerService.summaryRowCount = undefined;
                    this.customerService.customerSummary = undefined;
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                },
            );
        this.subscriptions.push(customersummarySubscription);
    }
    /**
     * Method scroll to top
     */
    public scrollTop() {
        this.domOperationUtilsService.scrollToTop('#customerGroupEditorTable');
    }

    /**
     * Method to add new customer
     * @param value - customerId which is an number
     */
    public updateCustomer(customer: GetCustomerSummary, customerId?: number) {
        // set customer id for editing
        this.statusCodeService.customerStatus.next(customer.active);
        this.statusCodeService.customerIdInEditName.next(customer.name);
        this.selectedCustomerID = customerId;
        this.customerID = customerId;
        this.openCreateCustomerEditor(true);
        this.statusCodeService.addNewCustomer.next(false);
        this.showUpdateCustomerEditor = true;
        this.scrollTop();
        this.statusCodeService.editedCustomerData.next(customer);

        const appQueryParams: AppQueryParams = {
                c: this.currentCustomerID,
                cid: customerId,
                lt: this.includeActiveInactiveLocations,
                s: !!this.searchString.value ? this.searchString.value : undefined,
                pi: !this.customerPaginator.pageIndex ? 0 : Number(this.customerPaginator.pageIndex),
                ps: this.customerPaginator.pageSize || undefined,
        }

        if(this.customerSort.active && this.customerSort.direction) {
            appQueryParams.psa = this.customerSort.active;
            appQueryParams.psd = this.customerSort.direction;
        }

        this.router.navigate(['/pages/customerEditor/details'], {
            queryParams: appQueryParams,
            relativeTo: this.activatedRoute,
        });
    }
    /**
     * Method to open customer editor
     */
    public openCreateCustomerEditor(isFromUpdate = false) {
        if (!isFromUpdate) {
            this.statusCodeService.addNewCustomer.next(true);
        }
        this.scrollTop();
        this.showNewCustomerEditor = true;
        this.showUpdateCustomerEditor = false;
        this.includeActiveInactiveLocations = Number(this.activatedRoute.snapshot.queryParamMap.get(activeInactiveLocationQueryParam));
        this.router.navigate(['/pages/customerEditor'], {
            queryParams: <AppQueryParams>{
                c: this.currentCustomerID,
                lt: this.includeActiveInactiveLocations
            },
            relativeTo: this.activatedRoute,
        });
    }
    /**
     * Method generates a table of customers
     */
    private generateUserTable(customers: GetCustomerSummary[]) {
        this.isLoading = true;
        this.filteredData = [];
        this.customerDataChange = new BehaviorSubject<GetCustomerSummary[]>([]);
        const customerCopiedData = this.filteredData;
        customers.map((customer: GetCustomerSummary) => {
            if (this.customerEdited !== null && this.customerEdited === customer.id) {
                customer.highlightRow = true;
                this.statusCodeService.customerIdInEditScreen.next(-1);
                this.uiUtilsService.safeChangeDetection(this.cdr);
                this.isCustomer = false;
            }
            customerCopiedData.push(customer);
            this.customerDataChange.next(customerCopiedData);
        });
        this.totalPaginationLength = this.rowCount;

        this.customerDataSource.data = customerCopiedData;

        this.isLoading = false;
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    /**
     * Destroy the subscription data
     */
    public ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
